// Overview presentation rules; raw values stay unchanged for charts and filtering.
export const roundedGap = (value: number) => Math.sign(value) * Math.round(Math.abs(value)) || 0;
export const overviewPercent = (value: number) =>
  value == null ? '—' : `${value !== 0 && Math.abs(value) < 9.95 ? value.toFixed(1) : Math.round(value)}%`;
export const overviewGap = (value: number, unit = true) => {
  const n = roundedGap(value);
  return `${n > 0 ? '+' : n < 0 ? '−' : ''}${Math.abs(n)}${unit ? ' pts' : ''}`;
};
export const overviewClubSignal = (club: any) => {
  if (club.capacityUsed > 100) return { text: 'Over capacity', tone: 'wr' };
  const signal = (club.signals || []).find(s =>
    /^(No register \d+ wks|−\d+% in 4 wks|Under \d+ for 3 wks|Waitlist \d+|Thriving)$/.test(s.text)
  );
  return signal ? { text: signal.text, tone: ['waitlist', 'thriving'].includes(signal.kind) ? 'up' : 'dn' } : null;
};
